import { FeedFilters } from '@/pages/Markets/MarketsComponents/Feed/api/fetchFeedData';

export const feedKeys = {
  all: ['feed'] as const,
  data: (metadata: FeedFilters) => [...feedKeys.all, metadata] as const
};
